<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintNumber border_bottom">
          <div class="left">投诉单号</div>
          <div class="right">{{item.mainComplainNumber}}</div>
        </div>
        <div class="complaintObject border_bottom">
          <div class="left">操作人</div>
          <div class="right" v-if="checkPerson.depts">{{checkPerson.depts[0].orgName}}-{{checkPerson.userInfo.name}}</div>
        </div>
      </div>
      <div class="reson"  v-for="(item, index) in type" :key="index" >
          <div class="reson_type">
              <div class="left">
                <span>指挥中心：</span>
                  <span>{{item.name}}</span>
              </div>
              <span class="right" @click="remove">删除</span>
          </div>
          <div class="reson_content">
              <span class="one">办理要求: </span>
              <div class="two">
                    {{item.reson}}
              </div>
          </div>
      </div>

      <div class="remark" v-show="isShow">
        <div class="addCommandCenter" @click="goType">添加指挥中心</div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button type="primary"  @click="sent">转办至下级</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import util from '../../../../utils/common'
    import api from '../../../../service/modules/complaintApis';
    export default {
        data () {
            return {
                type: this.$store.state.complaint.addType,
                isType: this.$store.state.complaint.workType.is_split,
                isShow: true,
                isback: this.$store.state.complaint.isBackDetail || util.getJsonLocal('isBack'),
                item: util.getJsonLocal('item'),
                flag: false
                // isShowBtn: false
            };
        },
        computed: {
            checkPerson () {
                console.log('this.$store.state.complaint.userInfo:', this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint'));
                return this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint')
            }
        },
        created () {
            this.getType();
        },
        methods: {
            remove (index) {
                this.type.splice(index, 1);
                this.isShow = true;
                this.$store.commit('complaint/resetType', this.type);
                
            },
            goType () {
                this.$router.push('/complaint/chooseCommandCenter')
            },
            getType () {
                let params={mainComplainNumber:this.item.mainComplainNumber}
                api.worker.getCenter(params).then((res) => {
                    if (res.ret === 0) {
                        const list = [];
                        if (res.data.list.length > 0) {
                            res.data.list.map((item, index) => {
                                list.push({ 'name': item.fullName, 'orgId': item.id })
                            })
                        }
                        // if (this.isType === 0) {
                        //     this.isShow = true
                        // } else if (this.isType === 1 && this.type.length !== 1) {
                        //     this.isShow = true;
                        // } else {
                        //     this.isShow = false;
                        // }

                        this.$store.commit('complaint/getType', list);
                    }
                })
            },
            sent () {
              // this.isShowBtn = true;
                if (this.type.length === 0) {
                    this.$Toast('请添加指挥中心');
                    return;
                }
                const orgIds = [];
                const contents = [];
                for (var i = 0; i < this.$store.state.complaint.addType.length; i++) {
                    orgIds.push(this.$store.state.complaint.addType[i].orgId);
                    contents.push(this.$store.state.complaint.addType[i].reson)
                }
                var params = {
                    'mainComplainNumber': this.item.mainComplainNumber,
                    'complainNumber':this.item.complainNumber,
                    'subId': this.item.subId,
                    'subPid': this.item.subPid,
                     orgIds,
                     contents:contents.join(',')
                }
                console.log(params);
                if (this.flag === false) {
                  this.flag = true;
                  api.worker.transformation(params).then((res) => {
                      if (res.ret === 0) {
                          this.$Toast('操作成功');
                          this.$router.back();
                          // this.isShowBtn = false;
                      }
                  })
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  height: 100%;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .complaintInformation {
      width: 100%;
      .complaintNumber,
      .complaintObject,
      .whetherApplyAplitting {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 30%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 70%;
          text-align: right;
          white-space: nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
        }
      }
      .complaintNumber {
        .right {
          color: blue;
        }
      }
    }
    .reson{
      width:100%;
      .reson_type{
        width:100%;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        margin-top:20px;
        span{
          color:#aaa;
        }
        .right{
          display: inline-block;
          padding:8px 14px;
          background-color: @base-color;
          border-radius: 6px;
          color:#fff;

        }
      }
      .reson_content{
        width:100%;
        margin-top:20px;
        .one{
          width:20%;
          display: inline-block;
          vertical-align: top;
          color:#aaa;
          margin-top:3px;
        }
        .two{
          width:80%;
          display: inline-block;
          vertical-align: top;
          color:#aaa;
          line-height: 1.4em;
        }
      }
    }
    .remark {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 20px;
      .titleName {
        color: #aaa;
        text-align: left;
      }
      .addCommandCenter {
          width: 70%;
          margin-left: 15%;
          font-size: 14px;
          height: 45px;
          line-height: 45px;
          color: #bbb;
          border: #ccc dashed 1px;
          text-align: center;
          margin-top: 15px;

      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
